import API from "../Services/API";
import Model from "./Model"

const useJobInvoiceChart = (alwaysRefresh = false, dateRange, groupBy) => {
    return Model({
        defaultData: null,
        stateKey: 'customer-job-invoice-chart',
        alwaysRefresh: alwaysRefresh,
        fetchData: () => API.get(`/customers/chart?dateRange=${dateRange}&groupBy=${groupBy}`),
        returnDataKey: 'chart',
        defaultLoadingError: 'Sorry, there was an error loading the chart.',
    })
}

const useCustomerReport = (alwaysRefresh = false) => {
    return Model({
        stateKey: 'customer-report',
        alwaysRefresh: alwaysRefresh,
        fetchData: () => API.get(`/customers/report`),
        returnDataKey: 'report',
        defaultLoadingError: 'Sorry, there was an error loading the report.',
    })
}

const useJobsReport = (alwaysRefresh = false) => {
    return Model({
        stateKey: 'jobs-report',
        alwaysRefresh: alwaysRefresh,
        fetchData: () => API.get(`/jobs/report`),
        returnDataKey: 'report',
        defaultLoadingError: 'Sorry, there was an error loading the report.',
    })
}


export {
    useJobInvoiceChart,
    useCustomerReport,
    useJobsReport,
};
